import InteractiveTemplate from '../../html/components/interactive.html'

import Component from '../shared/component'

import {Link, LinkMixin} from './link'

export const InteractiveMixin = {
  mixins: [
    LinkMixin
  ],
  computed: {
    interactive () {
      return this.href || this.$listeners.click
    }
  }
}

export const Interactive = Component('v-interactive', {
  components: [
    Link
  ],
  mixins: [
    InteractiveMixin
  ],
  template: InteractiveTemplate,
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    act () {
      this.$emit('action')
    }
  }
})
